<template>
  <v-dialog v-model="dialog" scrollable max-width="400px">
    <v-card>
      <v-card-title class="headline">Hak Akses Anda</v-card-title>
      <v-divider />
      <v-card-text>
        <v-expansion-panels focusable class="my-5" flat>
          <v-expansion-panel v-for="(operator, jenis) in operators" :key="jenis">
            <v-expansion-panel-header class="text-capitalize">{{ jenis }}</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-list flat dense>
                <template v-for="(item, i) in operator">
                  <v-list-item class="grey--text" :key="i" @click="onSwitch(jenis, $getAttr(item, `${jenis}_id`))">
                    <v-list-item-icon><v-icon>mdi-swap-horizontal</v-icon></v-list-item-icon>
                    <v-list-item-title class="grey--text text--darken-2">
                      {{ $getAttr($getIncluded(jenis, $getAttr(item, `${jenis}_id`)), 'nama') }}
                    </v-list-item-title>
                  </v-list-item>
                </template>
              </v-list>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click.native="dialog = false"> Batal </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      dialog: false,
    };
  },
  computed: {
    ...mapState('preferensi', {
      operators: (state) => (state.preferensi && state.preferensi.operators) || {},
      included: (state) => state.included,
    }),
  },
  methods: {
    open() {
      this.dialog = true;
    },

    onSwitch(jenis, id) {
      const codeOperator = {
        tenant: 'tn',
        organisasi: 'og',
        lokasi: 'lk',
        loket: 'lt',
      };
      const operator = codeOperator[jenis];

      this.dialog = false;
      this.$router.push({ name: 'home', params: { operator, id } });
    },
  },
};
</script>
